import React from "react"
import { useQuery } from "@apollo/client"
import ErrorLoading from "./ErrorLoading"
import Dashboard from "./Dashboard"
import Loading from "./Loading"
import { useRefetch } from "../../../hooks/useRefetch"
import { useMembershipJourney } from "../../../hooks/useMembershipJourney"
import { MEMBER_APPLICATION_ELIGIBILITY_QUERY } from "../../queries/memberApplicationEligibility"
import { COACH_TOOLS_API } from "../../../apolloClient"
import { flags, useFeatureFlags } from "../../../lib/feature-flags"

export const MembershipJourneyDashboardWrapper = ({
  authReady,
  onEditProfile,
  history,
}) => {
  const { isFetching, reload } = useRefetch()
  const { person, loading, error, refetch } = useMembershipJourney()
  const [isMemberApplicationChecklistEnabled = false] =
    useFeatureFlags([flags.FLAG_FEAT_MEMBER_APPLICATION_CHECKLIST]) ?? []
  const { data: eligibilityData } = useQuery(
    MEMBER_APPLICATION_ELIGIBILITY_QUERY,
    {
      context: { api: COACH_TOOLS_API },
      fetchPolicy: "cache-and-network",
      errorPolicy: "all",
      skip: !authReady || !isMemberApplicationChecklistEnabled,
    },
  )

  if (!authReady || loading || isFetching) {
    return <Loading />
  }

  const pgmProgress = person?.pgmProgress

  if (error || !pgmProgress || !person) {
    return <ErrorLoading refetch={refetch} reload={reload} />
  }

  return (
    <Dashboard
      me={person}
      pgmProgress={pgmProgress}
      onEditProfile={onEditProfile}
      history={history}
      authReady={authReady}
      isMemberApplicationChecklistEnabled={isMemberApplicationChecklistEnabled}
      memberApplicationEligibility={
        isMemberApplicationChecklistEnabled
          ? eligibilityData?.memberApplicationEligibility
          : undefined
      }
    />
  )
}

export default MembershipJourneyDashboardWrapper
